/*
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   selectorsPermAddress.ts
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'
import type { Object } from 'ts-toolbelt'

type PAState = Pick<State, 'permanentAddress'>
type DetailEntityState = Object.P.Pick<State, ['detail', 'entity', 'data']>

export const selectPermanentAddress = (state: PAState) => state.permanentAddress
export const selectPAAddress = compose(
  (state): (typeof state)['address'] => state?.address,
  selectPermanentAddress
)

export const selectActiveListings = compose(
  (state): NonNullable<(typeof state)['activeListings']> => state?.activeListings ?? [],
  selectPermanentAddress
)

export const selectInactiveListings = compose(
  (state): NonNullable<(typeof state)['inactiveListings']> => state?.inactiveListings ?? [],
  selectPermanentAddress
)

export const selectAllListings = (state: PAState) => {
  const activeListings = selectActiveListings(state)
  const inactiveListings = selectInactiveListings(state)
  return activeListings && inactiveListings
    ? activeListings.concat(inactiveListings)
    : (activeListings ?? inactiveListings)
}

export const selectDetailEntity = (state: DetailEntityState) => state.detail?.entity.data

export const selectIsSingleUnit = (state: DetailEntityState & PAState) => {
  const detailEntity = selectDetailEntity(state)
  const listingCount = selectAllListings(state).length
  return !!detailEntity && listingCount === 1
}
